import { useBreadcrumb } from "core/features/breadcrumbs";
import ContentTransferencias from "./components/ContentTransferencias";

function TransferenciasListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Transferências",
      url: "/financeiro/transferencias",
    },
  ]);

  return (
    <>
      <ContentTransferencias />
    </>
  );
}

export default TransferenciasListagemPage;
